<template>
  <v-card rounded="lg" height="100%" min-height="166">
    <v-card-title class="justify-center pt-2 pa-2 v-card__title">{{ title }}</v-card-title>
    <v-card-text
      class="text-card-value py-5"
      :style="styleObject"
    >{{ value % 1 > 0 ? value.toFixed(1) : value }}</v-card-text>
    <v-card-text class="text-card-unit" v-if="unit">{{ unit }}</v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TextCard',
  data() {
    return {}
  },
  props: {
    title: String,
    value: {
      type: Number,
      default: 0
    },
    unit: {
      type: String
    },
    color: String
  },
  computed: {
    styleObject() {
      return { color: this.color }
    }
  }
}
</script>

<style scoped>
.text-card-value {
  font-size: 40px;
  font-weight: bold;
  text-align: center;
}

.text-card-unit {
  font-size: 14px;
  font-weight: lighter;
  color: #999;
  text-align: center;
}
.v-card__title {
  font-size: 1.16rem !important;
}
</style>
